// Drum sample file imports and mapping
// These imports resolve to URLs via the bundler (CRA)
// Names align with instrumentConfigs.drums.drumMap entries

import kick from '../sample/OS_FLO_kick_punch.wav';
import snare from '../sample/058_a__Snare_-_DNBDRUMS_Zenhiser.wav';
import hihat from '../sample/OS_MN2_hihat_mini.wav';
import openhat from '../sample/MARS_909_open_hat_nice.wav';
import crash from '../sample/ZEN_GSG_crash_one_shot_standard.wav';
import ride from '../sample/tp_ud&b_rides_lingo.wav';
import tom1 from '../sample/TS_PAUL_MABURY_tom_one_shot_70s_rack_dry_h1.wav';
import tom2 from '../sample/TS_VHH_tom_mid_punch_dry.wav';
import tom3 from '../sample/TS_HMD_tom_sixteen_inch_floor_center_pan.wav';
import splash from '../sample/KJ666_Cym_oneshot_10in_Splash_01.wav';

// Export a simple mapping of drum name -> file URL
export const drumSampleFiles = {
  kick,
  snare,
  hihat,
  openhat,
  crash,
  ride,
  tom1,
  tom2,
  tom3,
  splash,
};

